
export interface GlobalizationState {
	currentlanguage: string,
}

export enum GlobalizationActionTypes {
    SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE',
}
